// Import FirebaseAuth and firebase.
import { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { firebaseConfig } from '../utils/firebaseConfig';
import { AuthUI } from './AuthUI';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import { saveOrUpdateUserOnLogin } from '../utils/dbAccess';
import { identifyUser } from '../utils/analytics';

firebase.initializeApp(firebaseConfig);

// Configure FirebaseUI.

function SignInScreen() {
  const [isSignedIn, setIsSignedIn] = useState(false); // Local signed-in state.
  const navigate = useNavigate();
  const uiConfig = {
    // signInSuccessUrl: '/',
    // Popup signin flow rather than redirect flow.
    signInFlow: 'redirect',

    // We will display Google and Facebook as auth providers.
    signInOptions: [
      {
        provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        customParameters: { prompt: 'select_account' },
      },
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: async function (authResult: any) {
        const user = authResult.user;
        console.log('User signed in:', user);

        try {
          await saveOrUpdateUserOnLogin({
            uid: user.uid,
            email: user.email ?? null,
            name: user.displayName ?? null,
            photoURL: user.photoURL ?? null,
          });
        } catch (e) {
          console.warn('Failed to save user to Firestore:', e);
        }

        // Keep userId, email, name in localStorage (same userId as in users collection for subscriptions)
        localStorage.setItem(
          'loggedInUser',
          JSON.stringify({
            userId: user.uid,
            email: user.email ?? undefined,
            name: user.displayName ?? undefined,
            displayName: user.displayName ?? undefined,
            photoURL: user.photoURL ?? undefined,
            uid: user.uid,
          }),
        );
        identifyUser(user.email || user.uid, {
          name: user.displayName,
          email: user.email,
        });
        navigate('/');
      },
    },
  };

  // Listen to the Firebase Auth state and set the local state.
  useEffect(() => {
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => {
      setIsSignedIn(!!user);
    });
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

  if (!isSignedIn) {
    return (
      <div>
        <p>Please sign-in:</p>
        <AuthUI uiConfig={uiConfig} />
      </div>
    );
  }
  return (
    <div className={'w-full flex flex-col gap-4 align-center justify-center'}>
      <p>Signed as {firebase.auth().currentUser?.displayName}</p>
      <PrimaryButton onClick={() => firebase.auth().signOut()} text={'Log out'}></PrimaryButton>
      <PrimaryButton variant={'dark'} onClick={() => navigate('/')} text={'Back'}></PrimaryButton>
    </div>
  );
}

export default SignInScreen;
